<template>
  <KModal header="Continue with Single Sign-On" v-model:visible="isVisible">
    <div class="k-modal__sso-content-wrapper">
      <BaseAlert type="caution" message="Sign in through your organization's portal." />

      <p>
        The organization associated with the provided email address uses Single Sign-On (SSO) to
        sign in to CareerSafe.
      </p>

      <p>You can access CareerSafe through your organization's portal.</p>
    </div>

    <template #footer>
      <div class="k-modal__buttons">
        <KButton label="Acknowledge" primary @click="hideModal" />
      </div>
    </template>
  </KModal>
</template>

<script setup lang="ts">
import { KButton, KModal } from "@k2united/frontend_components";
import BaseAlert from "@/components/base/BaseAlert.vue";
import { useRoute } from "vue-router";
import { ref } from "vue";

const route = useRoute();
const isVisible = ref(false);

const hideModal = () => {
  isVisible.value = false;
};

const showModal = () => {
  isVisible.value = true;
};

// Show the SSO modal if error=1 is in the URL
if (route.query.error === "1") {
  showModal();
}
</script>

<style scoped lang="scss">
.k-modal__sso-content-wrapper {
  p {
    @include body;
    color: $color-text-default;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }
}
.k-modal__buttons {
  justify-content: center;
}
</style>
